/** Quotes a field when it holds a comma, quote or line break, doubling any quotes inside it. */
function escapeCsvField(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/** Builds CSV text, one line per row, headers first. */
export function toCsv(headers: string[], rows: string[][]): string {
  return [headers, ...rows]
    .map(line => line.map(escapeCsvField).join(','))
    .join('\r\n');
}
